import { Card, H3, Separator } from '@betterment/samba-react';

import guideIcon from '~/b4b/images/b4b-resources-icon-guide.svg';
import hubIcon from '~/b4b/images/b4b-resources-icon-hub.svg';
import tourIcon from '~/b4b/images/b4b-resources-icon-tour.svg';
import webinarIcon from '~/b4b/images/b4b-resources-icon-webinar.svg';
import { urlBuilder } from '~/b4b/utils/urlBuilder';

import { ResourceCard } from './ResourceCard';

export const ForEmployees = () => {
  return (
    <Card css={{ p: 'space.300', flex: 1 }}>
      <Card.Header css={{ pb: 'space.300' }}>
        <H3 variant="title200">For employees</H3>
      </Card.Header>

      <Separator />

      <ResourceCard.Section icon={<img src={webinarIcon} alt="" />} label="Webinar">
        <ResourceCard.Row to={urlBuilder.resourcesNewEmployeeWebinar()}>
          <ResourceCard.Row.Title>Getting started</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Monthly live session to help new hires understand their 401(k).
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
      </ResourceCard.Section>

      <Separator />

      <ResourceCard.Section icon={<img src={tourIcon} alt="" />} label="Product demo">
        <ResourceCard.Row to={urlBuilder.resourcesProductDemo()}>
          <ResourceCard.Row.Title>Showcase Betterment to employees</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Guided product tour covering accounts, contributions, and investments.
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
      </ResourceCard.Section>

      <Separator />

      <ResourceCard.Section icon={<img src={hubIcon} alt="" />} label="Educational hub">
        <ResourceCard.Row to={urlBuilder.getEmployeeFinancialPlanningHub()}>
          <ResourceCard.Row.Title>Financial planning</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Articles, videos, and tutorials to help employees build better financial habits.
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
      </ResourceCard.Section>

      <Separator />

      <ResourceCard.Section icon={<img src={guideIcon} alt="" />} label="Guides">
        <ResourceCard.Row to={urlBuilder.resourcesBenefitsGuide()}>
          <ResourceCard.Row.Title>Explore Betterment benefits</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>Overview covering the plan's available benefits.</ResourceCard.Row.Description>
        </ResourceCard.Row>
        <ResourceCard.Row to={urlBuilder.resourcesMakingMostOf401k()}>
          <ResourceCard.Row.Title>Make the most of your 401(k)</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>Step-by-step instructions for account setup.</ResourceCard.Row.Description>
        </ResourceCard.Row>
        <ResourceCard.Row to={urlBuilder.resourcesRolloverGuide()}>
          <ResourceCard.Row.Title>Roll over a retirement account into Betterment</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            How to move outside retirement accounts into a 401(k).
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
        <ResourceCard.Row to={urlBuilder.resourcesDistributionGuide()}>
          <ResourceCard.Row.Title>Learn more about 401(k) distributions</ResourceCard.Row.Title>
          <ResourceCard.Row.Description>
            Guidance for terminated employees on withdrawing funds from their 401(k).
          </ResourceCard.Row.Description>
        </ResourceCard.Row>
      </ResourceCard.Section>
    </Card>
  );
};
